export const environment = {
  production: false,
  apiBaseUrl: 'https://docuty-api-test.insirion.com',
  backofficeUrl: 'https://docuty-test.insirion.com',
  registrationVersion: 'development-88e5f41',
  registrationCommitHash: '88e5f41',
  matomo: { url: 'https://matomo.docuty.de', siteId: '3' },
};
